import { Component, input } from '@angular/core'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { RouterLink } from '@angular/router'
import { NgxPermissionsAllowStubDirective, NgxPermissionsModule } from 'ngx-permissions'

@Component({
    selector: 'sf-sidebar-trial',
    imports: [ButtonComponent, RouterLink, NgxPermissionsAllowStubDirective, NgxPermissionsModule],
    templateUrl: './sidebar-trial.component.html',
    styleUrl: './sidebar-trial.component.scss',
})
export class SidebarTrialComponent {
    onTrial = input<boolean>(false)
    trialDaysLeft = input<number>(0)
}
